import type { LucideIcon } from "lucide-react-native";
import { CompactActionButton } from "@louise/moon-ui";
import { EMBER } from "@louise/moon-ui/theme/tokens";

export function CarePillActionButton({
  label,
  onPress,
  icon: Icon,
  trailingIcon: TrailingIcon,
  variant = "primary",
  surface = "default",
  flexGrow,
  flexBasis,
  minHeight,
  disabled = false,
}: {
  label: string;
  onPress: () => void;
  icon?: LucideIcon;
  trailingIcon?: LucideIcon;
  variant?: "primary" | "secondary";
  surface?: "default" | "selected";
  flexGrow?: number;
  flexBasis?: number;
  minHeight?: number;
  disabled?: boolean;
}) {
  const isPrimary = variant === "primary";
  const usesSelectedSurface = isPrimary && surface === "selected";
  const requestedBasis = flexBasis ?? (isPrimary ? 168 : 118);

  return (
    <CompactActionButton
      label={label}
      onPress={disabled ? undefined : onPress}
      disabled={disabled}
      variant={usesSelectedSurface ? "selected" : variant}
      size="md"
      leading={
        Icon ? (
          <Icon size={13} color={EMBER.colors.text} strokeWidth={1.9} />
        ) : null
      }
      trailing={
        TrailingIcon ? (
          <TrailingIcon size={13} color={EMBER.colors.text} strokeWidth={1.9} />
        ) : null
      }
      style={[
        {
          flexGrow: flexGrow ?? 0,
          minWidth: requestedBasis,
        },
        minHeight != null ? { minHeight } : null,
      ]}
    />
  );
}
